import { Box } from '@hivebrite/design-system/Box';
import { Divider } from '@hivebrite/design-system/Divider';

import { prepareDisplayedSections } from 'hb-react/frontoffice/apps/Jobs/utils/templateUtils';
import { useJobContext } from 'hb-react/frontoffice/apps/JobsV2/contexts/JobContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

const OtherInformation = () => {
  const { currentNetwork } = useDefaultAppContexts();
  const job = useJobContext();

  // Location is already displayed in the Header so we don't display it here
  const jobSections = prepareDisplayedSections(
    currentNetwork,
    job,
    true,
  ).filter(({ label }) => label !== I18n.t('web.shared.location.location'));

  if (jobSections.length === 0) {
    return null;
  }

  return (
    <>
      <Box mt={6} font="h3-semibold">
        {s__('JobsV2|Other Information')}
      </Box>
      <Divider mt={3} mb={4} />
      <Box flexWrap="wrap" data-testid="job-details-other-information">
        {jobSections.map((jobSection) => (
          <Box
            key={jobSection.label}
            pr={{ _: 0, xl: 4 }}
            flexDirection="column"
            width={{ _: '100%', xl: '50%' }}
            pb={5}
          >
            <Box font="metadata-semibold-asphalt" fontSize={16}>
              {jobSection.label}
            </Box>
            <Box font="metadata-regular-asphalt" pt={1}>
              {jobSection.value}
            </Box>
          </Box>
        ))}
      </Box>
    </>
  );
};

export default OtherInformation;
